import React, { Suspense } from 'react';
import UILoader from 'components/UI/Loader/Loader';
import BaseLayout from 'components/BaseLayout/BaseLayout';
import DocumentTitle from 'components/DocumentTitle/DocumentTitle';

const ClientList = React.lazy(() => import('components/Client/List/List'));

function ScreensClientsList() {
  return (
    <BaseLayout>
      <DocumentTitle>Clients</DocumentTitle>
      <Suspense fallback={<UILoader />}>
        <ClientList />
      </Suspense>
    </BaseLayout>
  );
}

export default ScreensClientsList;
